var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_9290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 39.3747C5.61328 40.215 6.28311 40.897 7.10837 40.897H48.9696C49.7948 40.897 50.4647 40.215 50.4647 39.3747C50.4647 38.5345 49.7947 37.8525 48.9694 37.8525H7.10837C6.28311 37.8525 5.61328 38.5345 5.61328 39.3747Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 5.88567V18.0634C35.5178 18.9037 36.1876 19.5857 37.0129 19.5857C37.8382 19.5857 38.508 18.9037 38.508 18.0634V5.88567C38.508 5.04541 37.8382 4.36341 37.0129 4.36341C36.1876 4.36341 35.5178 5.04541 35.5178 5.88567Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 30.2414V48.5081C35.5178 49.3483 36.1876 50.0303 37.0129 50.0303C37.8382 50.0303 38.508 49.3483 38.508 48.5081V30.2414C38.508 29.4012 37.8382 28.7192 37.0129 28.7192C36.1876 28.7192 35.5178 29.4012 35.5178 30.2414Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 60.6857V72.8635C35.5178 73.7037 36.1876 74.3857 37.0129 74.3857C37.8382 74.3857 38.508 73.7037 38.508 72.8635V60.6857C38.508 59.8455 37.8382 59.1635 37.0129 59.1635C36.1876 59.1635 35.5178 59.8455 35.5178 60.6857Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4347 39.3747C59.4347 40.215 60.1046 40.897 60.9298 40.897H72.8901C73.7154 40.897 74.3852 40.215 74.3852 39.3747C74.3852 38.5345 73.7154 37.8525 72.8901 37.8525H60.9298C60.1046 37.8525 59.4347 38.5345 59.4347 39.3747Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 5.88567V72.8635C5.61328 73.7037 6.28311 74.3857 7.10837 74.3857H48.9696C49.7917 74.3857 50.4645 73.7037 50.4645 72.8635V69.8191C50.4645 68.9788 49.7947 68.2968 48.9694 68.2968C48.1442 68.2968 47.4745 68.9788 47.4745 69.8191V71.3413H9.12205V9.42332H70.8764V71.3413H62.4248V69.8191C62.4248 68.9788 61.755 68.2968 60.9297 68.2968C60.1044 68.2968 59.4347 68.9788 59.4347 69.8191V72.8635C59.4347 73.7037 60.1046 74.3857 60.9298 74.3857H72.8901C73.7154 74.3857 74.3852 73.7037 74.3852 72.8635V5.88567C74.3852 5.04541 73.7154 4.36341 72.8901 4.36341H7.10837C6.28311 4.36341 5.61328 5.04541 5.61328 5.88567Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4707 36.3302V42.4191C47.4707 43.2594 48.1405 43.9414 48.9657 43.9414C49.791 43.9414 50.4607 43.2594 50.4607 42.4191V36.3302C50.4607 35.49 49.7909 34.808 48.9656 34.808C48.1403 34.808 47.4707 35.49 47.4707 36.3302Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4347 36.3302V42.4191C59.4347 43.2594 60.1046 43.9414 60.9298 43.9414C61.7551 43.9414 62.4249 43.2594 62.4249 42.4191V36.3302C62.4249 35.49 61.7551 34.808 60.9298 34.808C60.1046 34.808 59.4347 35.49 59.4347 36.3302Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 60.6858C32.524 61.526 33.1938 62.208 34.0191 62.208H39.9994C40.8245 62.208 41.4943 61.526 41.4943 60.6858C41.4943 59.8455 40.8245 59.1635 39.9992 59.1635H34.019C33.1938 59.1635 32.524 59.8455 32.524 60.6858Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 48.5081C32.524 49.3483 33.1938 50.0303 34.0191 50.0303H39.9993C40.8246 50.0303 41.4944 49.3483 41.4944 48.5081C41.4944 47.6678 40.8244 46.9858 39.9992 46.9858H34.019C33.1938 46.9858 32.524 47.6678 32.524 48.5081Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 30.2414C32.524 31.0817 33.1938 31.7637 34.0191 31.7637H39.9993C40.8246 31.7637 41.4944 31.0817 41.4944 30.2414C41.4944 29.4012 40.8244 28.7192 39.9992 28.7192H34.019C33.1938 28.7192 32.524 29.4012 32.524 30.2414Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 18.0634C32.524 18.9037 33.1938 19.5857 34.0191 19.5857H39.9993C40.8246 19.5857 41.4944 18.9037 41.4944 18.0634C41.4944 17.2232 40.8246 16.5412 39.9993 16.5412H34.0191C33.1938 16.5413 32.524 17.2232 32.524 18.0634Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 39.3747C5.61328 40.215 6.28311 40.897 7.10837 40.897H48.9696C49.7948 40.897 50.4647 40.215 50.4647 39.3747C50.4647 38.5345 49.7947 37.8525 48.9694 37.8525H7.10837C6.28311 37.8525 5.61328 38.5345 5.61328 39.3747Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 5.88567V18.0634C35.5178 18.9037 36.1876 19.5857 37.0129 19.5857C37.8382 19.5857 38.508 18.9037 38.508 18.0634V5.88567C38.508 5.04541 37.8382 4.36341 37.0129 4.36341C36.1876 4.36341 35.5178 5.04541 35.5178 5.88567Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 30.2414V48.5081C35.5178 49.3483 36.1876 50.0303 37.0129 50.0303C37.8382 50.0303 38.508 49.3483 38.508 48.5081V30.2414C38.508 29.4012 37.8382 28.7192 37.0129 28.7192C36.1876 28.7192 35.5178 29.4012 35.5178 30.2414Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5178 60.6857V72.8635C35.5178 73.7037 36.1876 74.3857 37.0129 74.3857C37.8382 74.3857 38.508 73.7037 38.508 72.8635V60.6857C38.508 59.8455 37.8382 59.1635 37.0129 59.1635C36.1876 59.1635 35.5178 59.8455 35.5178 60.6857Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4347 39.3747C59.4347 40.215 60.1046 40.897 60.9298 40.897H72.8901C73.7154 40.897 74.3852 40.215 74.3852 39.3747C74.3852 38.5345 73.7154 37.8525 72.8901 37.8525H60.9298C60.1046 37.8525 59.4347 38.5345 59.4347 39.3747Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 5.88567V72.8635C5.61328 73.7037 6.28311 74.3857 7.10837 74.3857H48.9696C49.7917 74.3857 50.4645 73.7037 50.4645 72.8635V69.8191C50.4645 68.9788 49.7947 68.2968 48.9694 68.2968C48.1442 68.2968 47.4745 68.9788 47.4745 69.8191V71.3413H9.12205V9.42332H70.8764V71.3413H62.4248V69.8191C62.4248 68.9788 61.755 68.2968 60.9297 68.2968C60.1044 68.2968 59.4347 68.9788 59.4347 69.8191V72.8635C59.4347 73.7037 60.1046 74.3857 60.9298 74.3857H72.8901C73.7154 74.3857 74.3852 73.7037 74.3852 72.8635V5.88567C74.3852 5.04541 73.7154 4.36341 72.8901 4.36341H7.10837C6.28311 4.36341 5.61328 5.04541 5.61328 5.88567Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4707 36.3302V42.4191C47.4707 43.2594 48.1405 43.9414 48.9657 43.9414C49.791 43.9414 50.4607 43.2594 50.4607 42.4191V36.3302C50.4607 35.49 49.7909 34.808 48.9656 34.808C48.1403 34.808 47.4707 35.49 47.4707 36.3302Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4347 36.3302V42.4191C59.4347 43.2594 60.1046 43.9414 60.9298 43.9414C61.7551 43.9414 62.4249 43.2594 62.4249 42.4191V36.3302C62.4249 35.49 61.7551 34.808 60.9298 34.808C60.1046 34.808 59.4347 35.49 59.4347 36.3302Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 60.6858C32.524 61.526 33.1938 62.208 34.0191 62.208H39.9994C40.8245 62.208 41.4943 61.526 41.4943 60.6858C41.4943 59.8455 40.8245 59.1635 39.9992 59.1635H34.019C33.1938 59.1635 32.524 59.8455 32.524 60.6858Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 48.5081C32.524 49.3483 33.1938 50.0303 34.0191 50.0303H39.9993C40.8246 50.0303 41.4944 49.3483 41.4944 48.5081C41.4944 47.6678 40.8244 46.9858 39.9992 46.9858H34.019C33.1938 46.9858 32.524 47.6678 32.524 48.5081Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 30.2414C32.524 31.0817 33.1938 31.7637 34.0191 31.7637H39.9993C40.8246 31.7637 41.4944 31.0817 41.4944 30.2414C41.4944 29.4012 40.8244 28.7192 39.9992 28.7192H34.019C33.1938 28.7192 32.524 29.4012 32.524 30.2414Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.524 18.0634C32.524 18.9037 33.1938 19.5857 34.0191 19.5857H39.9993C40.8246 19.5857 41.4944 18.9037 41.4944 18.0634C41.4944 17.2232 40.8246 16.5412 39.9993 16.5412H34.0191C33.1938 16.5413 32.524 17.2232 32.524 18.0634Z",
    stroke: "#404041",
    strokeWidth: 2.4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.36328,
    y: 4.36426,
    width: 71.2719,
    height: 71.2719,
    rx: 2.25,
    stroke: "#404041",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_9290"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.61328,
    y: 5.61426,
    width: 68.7719,
    height: 68.7719,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplan);
export default __webpack_public_path__ + "static/media/floorplan.7b784ce5465790bc11f1df3136c6134c.svg";
export { ForwardRef as ReactComponent };